"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setScopes = setScopes;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

function setScopes(scopes) {
  return {
    type: _ActionTypes.SET_SCOPES,
    scopes: scopes
  };
}